export default __webpack_public_path__ + "static/media/plus-circle_white.9e37e02c.svg";